import React from 'react';
import { Col, Form } from 'react-bootstrap';

export default class SelectForm_City extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            language: 'rus',
            id: '',
            fid: '',
            description: '',
            information: '',
            value: '',
            colorError: '#fff'
        }

        this.handleChange = this.handleChange.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
        this.viewListOptions = this.viewListOptions.bind(this);

    }

    async handleBlur(e) {
        await this.setState({
            id: e.target.dataset.id,
            fid: `${this.props.nameForm}_${this.props.id}`,
            description: e.target.dataset.description,
            information: e.target.dataset.information
        })
        this.props.onChangeValue(this.state)
    }

    handleChange(e) {
        e.preventDefault();
        console.log(e.target.value);//test
        this.setState({ value: e.target.value })
        this.props.onChangeVisionBlock(e.target.value, e);
    }

    viewListOptions(arr) {
        this.optionArr = [];
        arr.forEach((data, index) => {
            this.optionArr.push(
                <option key={index} >{data}</option>
            )
        })
    }

    componentDidMount() {
        this.setState({ value: this.props.value })

        this.viewListOptions(this.props.option)
    }

    render() {

        const width = this.props.width;
        // const label = this.props.label;
        const label = this.props.placeholder;
        const id = this.props.id;
        const description = this.props.description;
        const placeholder = this.props.placeholder;
        const value = this.state.value;
        const show = this.props.show;


        return (
            <React.Fragment key={id}>
                <Col sm={width} style={{ visibility: show ? 'visible' : 'collapse' }} >
                    <Form.Label className={this.props.labelSmall && 'phone_mask_label'} ><b>{label}</b></Form.Label>
                    <Form.Control
                        as="select"
                        type="text"
                        data-id={id}
                        placeholder={placeholder}
                        data-information={placeholder}
                        data-description={description}
                        value={value}
                        onChange={this.handleChange}
                        onBlur={this.handleBlur}
                        disabled={this.props.readOnly}
                    >
                        <option key={placeholder}>{placeholder}</option>
                        {/* <option key={placeholder}></option> */}
                        {this.optionArr}
                    </Form.Control>
                </Col>
            </React.Fragment>
        )
    }
}